/**
 * @argus/permissions-catalogue — the frontend permission catalogue (ENG-10).
 *
 * The catalogue itself is GENERATED from the backend `ROLE_PERMISSIONS`
 * (`catalogue.generated.ts` — do not edit). This barrel re-exports it and adds the
 * pure membership helpers the UI gates consume, so components never hard-code a
 * permission string literal (CC-2): they ask `roleCan(role, 'firm.write')`.
 *
 * Framework-agnostic on purpose (no React) so the same catalogue can back any
 * consumer. The React `<Can>` gate lives in the web app (`apps/web/src/lib/permissions`).
 */
export type { Permission, Role } from './catalogue.generated.ts';
import {
  ALL_PERMISSIONS,
  ROLE_PERMISSIONS,
  type Permission,
  type Role,
} from './catalogue.generated.ts';

export { ALL_PERMISSIONS, ROLE_PERMISSIONS };

/** The six canonical roles, in catalogue order. */
export const ALL_ROLES: readonly Role[] = Object.keys(ROLE_PERMISSIONS) as Role[];

/** True iff `role`'s generated catalogue grants `permission` (the UI-gate primitive). */
export function roleCan(role: Role, permission: Permission): boolean {
  const perms = ROLE_PERMISSIONS[role];
  return perms !== undefined && perms.includes(permission);
}

/** Runtime guard — is `value` one of the six canonical roles? */
export function isRole(value: string): value is Role {
  return Object.prototype.hasOwnProperty.call(ROLE_PERMISSIONS, value);
}

/** Runtime guard — is `value` a catalogued permission? */
export function isPermission(value: string): value is Permission {
  return (ALL_PERMISSIONS as readonly string[]).includes(value);
}
